module.exports = __webpack_public_path__ + "img/Metastasis-LICA_GSE146409.88ce53b8.png";